import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import history from '../../../lib/history'
import * as reducks from '../../../reducks'
import * as modals from '../../../constants/modals'
import ModalFeedback from '../ModalFeedback/ModalFeedback'
import Text from '../Text/Text'
import Button from '../Button/Button'

const Alert = () => {
  const id = useSelector((state) => state.modalReducer.content.id)
  const { title, message, action, route } = useSelector(
    (state) => state.alertsReducer.content
  )
  const visible = id === modals.ALERT_MODAL_ID

  const dispatch = useDispatch()
  const handleClose = () =>
    dispatch(reducks.resources.alerts.actions.closeAlert())

  const handleRedirect = () => {
    handleClose()
    history.push(route)
  }

  const ALERT_ACTIONS = {
    default: () => handleClose(),
    redirect: () => handleRedirect()
  }

  const newAction = action && ALERT_ACTIONS[action]

  return (
    <ModalFeedback visible={visible} closeCallback={() => handleClose()}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Text color="gray" variation="dark" size="lg">
          {title}
        </Text>
        <Text
          font="custom"
          size="sm"
          color="gray"
          variation="light"
          lineHeight="30px"
          alignText="center"
          margin="24px 0px 6px 0px"
        >
          {message}
        </Text>

        {newAction ? (
          <Button
            type="secondary"
            margin="24px 0 0"
            width="300px"
            onClick={newAction}
          >
            <Text font="custom" color="white" size="xs" value="OK" bold />
          </Button>
        ) : null}
      </div>
    </ModalFeedback>
  )
}

export default Alert
